import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { isRaterDone } from 'cxray-utilities/mbo/calculations';
import { DOUGHNUT_CHART_COLORS, STATUS } from '../../utils/const';
import CardSelectorAndEvaluationDialogContainer from './CardSelectorAndEvaluationDialogContainer';
import { EvaluationStatusButton } from './EvaluationStatusButton';

const CriteriaEvaluationsGroupedByEmployees = ({ objective, objectiveRates, onSubmitSuccess }) => {
  const { t } = useTranslation();

  const { appraisers, criterias } = objective.appraisers_and_criterias;
  const idOfCurrentUser = objective.employee_id;

  const appraisersWithCurrentUserFirst = [
    ...appraisers.filter(appraiser => appraiser.employee_id === idOfCurrentUser),
    ...appraisers.filter(appraiser => appraiser.employee_id !== idOfCurrentUser)
  ];

  const getEvaluationRate = ( objectiveRates, employeeId, criterion) => (
    objectiveRates.find(
      rate => rate.rated_by === employeeId && rate.criteria.criteria_id === criterion.criteria_id
    ) ?? { objective_id: objective.objective_id, criteria: criterion }
  );

  const getIfRateable = (employeeId, evaluationClosed) => (
    employeeId === idOfCurrentUser &&
      objective.status === STATUS.COMPLETED &&
        !evaluationClosed
  );

  const getColorForDoughnutChart = employeeId => (
    idOfCurrentUser === employeeId ?
      DOUGHNUT_CHART_COLORS.BLUE : DOUGHNUT_CHART_COLORS.PURPLE
  );

  const getEvaluationStatusText = evaluationClosed => (
    evaluationClosed ?
      t('objective.appraiser.status.closed') : t('objective.appraiser.status.inProgress')
  );

  const useStyles = makeStyles({
    name: {
      color: '#999999',
      fontSize: '16px',
      textTransform: 'uppercase'
    },
    infoBox: {
      margin: '5px'
    }
  });

  const classes = useStyles();

  return appraisersWithCurrentUserFirst.map(appraiser => (
    <Grid key={ appraiser.employee_id } item>
      <Typography className={ classes.name }>
        {`${appraiser.name}
         ${t('objective.appraiser.evaluation')}
         ${getEvaluationStatusText(appraiser.evaluationClosed)}`}
      </Typography>

      {appraiser?.employee_id !== idOfCurrentUser &&
      appraiser?.evaluationClosed !== true ? (
          <Typography className={ classes.infoBox }>
            {t('objective.average.not_available_yet')}
          </Typography>
        ) : (
          criterias.map(criterion => (
            <CardSelectorAndEvaluationDialogContainer
              key={ criterion.criteria_id }
              rate={ getEvaluationRate(
                objectiveRates,
                appraiser.employee_id,
                criterion
              ) }
              rateable={ getIfRateable(
                appraiser.employee_id,
                appraiser.evaluationClosed
              ) }
              doughnutChartColor={ getColorForDoughnutChart(appraiser.employee_id) }
              idOfCurrentUser={ idOfCurrentUser }
              onSubmitSuccess={ onSubmitSuccess }
            />
          ))
        )}
      <EvaluationStatusButton
        rateable={ getIfRateable(
          appraiser.employee_id,
          appraiser.evaluationClosed
        ) }
        raterDone={ isRaterDone(
          objective,
          objectiveRates,
          appraiser.employee_id
        ) }
        isEvaluationClosed={ !!appraiser.evaluationClosed }
        isCurrentUser={ idOfCurrentUser === appraiser.employee_id }
        objective={ objective }
        appraiserId={ appraiser.employee_id }
        onSubmitSuccess={ onSubmitSuccess }
      />
    </Grid>
  ));
};

export default CriteriaEvaluationsGroupedByEmployees;
